<template lang="pug">
DynamicHtmlElement(
  v-if="partInfo.html"
  :tag="partInfo.html.tag"
  :html="partInfo.html.innerHTML"
  v-bind="partInfo.html.attributes"
)
CollapsibleList(
  v-else-if="partInfo.collapse"
  :title="partInfo.collapse.data.title"
)
  CollapsibleListItem(
    v-for="(collapsibleItem, index) in partInfo.collapse.data.items"
    :key="index"
    :title="collapsibleItem.title"
    :badge-value="collapsibleItem.badgeValue"
  )
    template(#header)
      div(v-html="collapsibleItem.title")
    div(v-html="collapsibleItem.content")
</template>

<script setup lang="ts">
import type { CommentBodyPartInfo } from "~/components/commentBody.util.types";
import DynamicHtmlElement from "~/components/DynamicHtmlElement";

interface Props {
  part: CommentBodyPartInfo;
}

const props = withDefaults(defineProps<Props>(), {});

// Workaround for https://youtrack.jetbrains.com/issue/WEB-62974/Vue-type-narrowing-doesnt-work-in-Pug-template
const partInfo = computed(() => ({
  html: props.part.type === "HTML" ? props.part : null,
  collapse: props.part.type === "COLLAPSE" ? props.part : null,
}));
</script>
